import { render, staticRenderFns } from "./ficha-turno-1.vue?vue&type=template&id=39fc32a2&scoped=true&"
import script from "./ficha-turno-1.vue?vue&type=script&lang=js&"
export * from "./ficha-turno-1.vue?vue&type=script&lang=js&"
import style0 from "./ficha-turno-1.vue?vue&type=style&index=0&id=39fc32a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39fc32a2",
  null
  
)

export default component.exports